import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    done: 'Done!',
    doneDescription:
      '{inAmount} {mainToken} staked successfully!<br /> {outAmount} {stakeToken} was sent to your wallet.',
    buttonText: 'Perfect!',
  },
};
